import invoiceRequests from '../../server/invoice';
import { addLoading, removeLoading } from './loading';

// eslint-disable-next-line import/prefer-default-export
export const getInvoiceDetails = (invoiceNumber, clientId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return invoiceRequests.getInvoiceDetails(invoiceNumber, clientId);
  } finally {
    dispatch(removeLoading());
  }
};
